(() => {
	angular.module('main').directive('contactFullName', () => ({
		restrict: 'E',
		scope: {
			contact: '='
		},
		template: '<b>{{contact.firstName}} {{contact.lastName}}</b>',
		replace: true,
		transclude: true,
		link(scope, element) {}
	}));
})();



// WEBPACK FOOTER //
// ./web/js/components/Filelds/contactFullName.js